import React, { useEffect, useState, useRef } from 'react';
import { Button, Form, Input, Checkbox, Select, Space, message, Spin, Modal, InputNumber, List, notification } from 'antd';
import {
	getUsers,
	getUser,
	addMeals,
	getMeals,
	getChat,
	getMealsByID,
	addOrUpdateDish,
	updateMeals,
} from '../../service/auth/AuthService';
import type { ColumnsType } from 'antd/es/table';
import Moment from 'moment';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { formatMoney } from '../../helper/formatCurrencyHelper';

import './Dish.scss';
import { initial, iteratee } from 'lodash';
import { Wheel } from 'react-custom-roulette'

export default function Dish() {
	const [isSpin, setIsSpin] = useState(false);
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [formDish] = Form.useForm();
	const [formMessage] = Form.useForm();
	const [userRender, setUserRender] = useState<any>([]);
	const [numberUserId, setNumberUserId] = useState(0);
	const [arrayUserDish, setArrayUserDish] = useState<any>([]);
	const [arrCountDish, setArrayCountDish] = useState<any>([]);
	const [meal, setMeal] = useState<any>([]);
	const [totalMustPay, setTotalMustPay] = useState<any>(0);
	const [idCreator, setIdCreator] = useState<number>();
	const [dateMeals, setDateMeals] = useState('');
	const [userName, setUserName] = useState<any>('');
	const [userColor, setUserColor] = useState<any>('#000');

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isChatOpen, setIsChatOpen] = useState(false);
	const [isRandomOpen, setIsRandomOpen] = useState(false);
	const [isOpenShowList, setIsOpenShowList] = useState(false);
	const [totalPay, setTotalPay] = useState(0);
	const [ws, setWs] = useState(Object);
	const [numberconnect, setNumberconnect] = useState(0);
	const [arrMessage, setArrMessage] = useState<any>([]);

	const [dataRandom, setDataRandom] = useState([{ option: '0' },
	{ option: '1' },
	{ option: '2' },]);

	const [textRandom, setTextRandom] = useState("");

	const [mustSpin, setMustSpin] = useState(false);
	const [prizeNumber, setPrizeNumber] = useState(0);

	// const typingTimeoutRef = useRef(null);

	if (arrayUserDish.length > 0) {
		formDish.setFieldsValue({
			modules: arrayUserDish,
		});
	}

	if (arrMessage.length > 0) {
		formMessage.setFieldsValue({
			modules: arrayUserDish,
		});
	}
	// console.log(meal);
	const numberMealId = searchParams.get('mealid');
	useEffect(() => {
		const totalInitial = arrayUserDish.reduce((initialTotal: any, item: any, index: number) => {
			return initialTotal + item.price;
		}, 0);
		setTotalPay(totalInitial);
	}, [arrayUserDish]);

	useEffect(() => {
		getUsers()
			.then(res => {
				// console.log(res);
				setUserRender(res.data.data);
			})
			.catch(err => {
				// console.log(err);
			});
		getUser()
			.then((res: any) => {
				// console.log(res);
				setNumberUserId(res.data.data.id);
				setUserName(res.data.data.fullname);
				setUserColor(res.data.data.color);
				initWS(res.data.data.id);
			})
			.catch(err => {
				// console.log(err);
			});
		getMealsByID(numberMealId)
			.then(res => {
				// console.log(res);
				setDateMeals(res.data.result.created);
				setIdCreator(res.data.result.creator);
				setMeal(res.data.result);
				setTotalMustPay(res.data.result.totalneed2pay);
				// updateArrayDishes();
			})
			.catch(err => {
				// console.log(err);
			});

		getChat()
			.then(res => {
				// console.log(res);
				setArrMessage(res.data.data);
				// updateArrayDishes();
			})
			.catch(err => {
				// console.log(err);
			});

		// console.log('i fire once');
		setNumberconnect(1);
	}, []);

	useEffect(() => {
		updateArrayDishes();
	}, [userRender, meal]);

	const openNotification = (text: string) => {
		notification.open({
			message: `${text}`,
			onClick: () => {
				// console.log('Notification Clicked!');
			},
		});
	};

	function initWS(numberUserId: number) {
		if (numberconnect == 0) {
			// console.log("here");
			const client_id = numberUserId;
			const ws = new WebSocket(`wss://foodyy-api.shapeecloud.com/ws/dishes/${client_id}`);
			// const ws = new WebSocket(`ws://localhost:8000/ws/dishes/${client_id}`);
			console.log(ws);
			setWs(ws);
			setNumberconnect(1);
			ws.onmessage = function (event: any) {
				console.log("receive");
				receiveWithType(event.data, numberUserId)
			};
		}
	}

	function sendWithType(type: number, text: string) {
		// console.log("abc");
		if (type == 1) {
			ws.send(`${numberUserId}-${userName} join-${type}`);
		} else if (type == 2) {
			ws.send(`${numberUserId}-${userName} left-${type}`);
		} else if (type == 3) {
			console.log("333");
			ws.send(`${numberUserId}-${userName} ${text}-${type}`);
		} else {
			console.log("444");
			ws.send(`${numberUserId}-${text}-${type}`);
		}
	}

	function receiveWithType(text: string, numberUserId: number) {
		const arrtext = text.split("-");
		console.log(arrtext);
		if (arrtext.length > 2) {
			const type = arrtext[2];
			const user_id = arrtext[0];
			// console.log(user_id);
			// console.log(numberUserId.toString());
			console.log(user_id === numberUserId.toString());
			if (type == "4") {
				const textReceive = `${arrtext[1]}`;
				console.log(textReceive);
				const arrMessageAdd: any = [];

				const arrTextUser = textReceive.split("===");

				for (let i = 0; i < arrTextUser.length; i++) {
					const data = arrTextUser[i].split("==");
					arrMessageAdd.push({
						"name": data[0],
						"message": data[1],
						"created": data[2],
						"color": data[3]
					});
				}

				// console.log(arrMessageAdd);
				setArrMessage(arrMessageAdd);
			} else {
				if (user_id === numberUserId.toString() || numberUserId.toString() == "0") {
					// return;
				} else {
					if (type == "1") {
						// 1. login
						const textReceive = `${arrtext[1]}`;
						openNotification(textReceive);
					} else if (type == "2") {
						// 2. logout
						const textReceive = `${arrtext[1]}`;
						openNotification(textReceive);
					} else if (type == "3") {
						// 3. order
						console.log("order");
						const textReceive = `${arrtext[1]}`;
						refreshRealtime(textReceive)
						// handleClickFresh()
					} else {
						// 4. orther
					}
				}
			}
		}
	}


	function updateArrayDishesRealtime(userRender: any, meal: any, dateMeals: any) {
		const userDishers: any = [];
		const userRenderSort = userRender?.sort(function (x: any, y: any) { return x.id == numberUserId ? -1 : y.id == numberUserId ? 1 : 0; });
		userRender?.map((user: any, index: number) => {
			let check = false;
			let mealid = 0;
			meal.dishes?.forEach((dish: any) => {
				if (dish.userid == user.id) {
					check = true;
					userDishers[index] = dish;
					userDishers[index].isOrderForFriend = true
				}
				mealid = dish.mealid;
			});
			if (!check) {
				userDishers[index] = {
					userid: user.id,
					mealid: meal.id,
					name: '',
					price: 0,
					need2pay: 0,
					status: 'new',
					created: dateMeals,
					modified: dateMeals,
					isOrderForFriend: true
				};
			}
		});
		setUserRender(userRenderSort);
		setArrayUserDish(userDishers);

		// console.log(userRenderSort);
		// console.log(userDishers)
	}

	function updateArrayDishes() {
		const userDishers: any = [];
		const userRenderSort = userRender.sort(function (x: any, y: any) { return x.id == numberUserId ? -1 : y.id == numberUserId ? 1 : 0; });
		userRender?.map((user: any, index: number) => {
			let check = false;
			let mealid = 0;
			meal.dishes?.forEach((dish: any) => {
				if (dish.userid == user.id) {
					check = true;
					userDishers[index] = dish;
					userDishers[index].isOrderForFriend = true
				}
				mealid = dish.mealid;
			});
			if (!check) {
				userDishers[index] = {
					userid: user.id,
					mealid: meal.id,
					name: '',
					price: 0,
					need2pay: 0,
					status: 'new',
					created: dateMeals,
					modified: dateMeals,
					isOrderForFriend: true
				};
			}
		});
		setUserRender(userRenderSort);
		setArrayUserDish(userDishers);

		// console.log(userRenderSort);
		// console.log(userDishers)
	}

	const onFinish = (values: any) => {
		// console.log('Success:', values);
		const values_module = values.modules;
		// console.log(values_module);

		if (idCreator === numberUserId) {
			// gửi các món user đã chọn lên
			addOrUpdateDish(values_module)
				.then(res => {
					// console.log(res);
					// console.log("Đã đặt món");
					sendWithType(3, `đã đặt món`);
					message.success('Bạn đã cập nhật thành công');
				})
				.catch(err => {
					// console.log(err);
					message.error('Đã xảy ra lỗi');
				});
			// update giá tiền phải trả need2pay
			const total = arrayUserDish.reduce((initialTotal: any, item: any, index: number) => {
				return initialTotal + item.price;
			}, 0);
			setTotalPay(total);
			const paramsMeal = {
				shoplink: meal.shoplink,
				shopprice: total > 0 ? total : 0,
				totalneed2pay: parseInt(totalMustPay),
				// != 0 ? parseInt(totalMustPay) : meal.totalneed2pay,
				creator: meal.creator,
				payer: meal.payer,
				status: 'new',
				created: new Date().toISOString(),
				modified: new Date().toISOString(),
			};

			// console.log(paramsMeal);
			updateMeals(paramsMeal, numberMealId)
				.then(res => {
					// console.log(res);
					// message.success('Bạn đã cập nhật thành công');
				})
				.catch(err => {
					// console.log(err);
				});
		} else {
			// gửi các món user đã chọn lên
			const dishChange: any = [];
			values_module.find((itemDad: any, indexChild: number) => {
				if (itemDad.userid === numberUserId || itemDad.isOrderForFriend == false) {
					dishChange.push(itemDad);
				}
			});

			const paramsSendDish: any = [];
			dishChange.forEach((element: any) => {
				paramsSendDish.push({
					name: element.name,
					price: parseInt(element.price),
					need2pay: parseInt(element.need2pay),
					userid: element.userid,
					mealid: meal.id,
					status: 'new',
					created: new Date().toISOString(),
					modified: new Date().toISOString(),
				})
			});

			// console.log(paramsSendDish);

			addOrUpdateDish(paramsSendDish)
				.then(res => {
					// console.log(res);
					// console.log("Đã đặt món");
					sendWithType(3, `đã đặt món`);
					// message.success('Bạn đã cập nhật thành công');
				})
				.catch(err => {
					// console.log(err);
				});
			// update giá tiền phải trả need2pay
			const total = arrayUserDish.reduce((initialTotal: any, item: any, index: number) => {
				return initialTotal + item.price;
			}, 0);
			setTotalPay(total);

			const paramsMeal = {
				shoplink: meal.shoplink,
				shopprice: total,
				totalneed2pay: parseInt(totalMustPay),
				//!= 0 ? parseInt(totalMustPay) : meal.totalneed2pay
				creator: meal.creator,
				payer: meal.payer,
				status: 'new',
				created: new Date().toISOString(),
				modified: new Date().toISOString(),
			};

			// console.log(paramsMeal);

			updateMeals(paramsMeal, numberMealId)
				.then(res => {
					// console.log(res);
					message.success('Bạn đã cập nhật thành công');
				})
				.catch(err => {
					// console.log(err);
				});
		}
	};

	const handleChangePrice = (e: any, indexDad: any) => {
		if (!e) {
			e = 0;
		} else {
			e = e.toString().replaceAll('.', '');
			e = e.toString().replaceAll('-', '');
		}

		// console.log(e);
		if (idCreator === numberUserId || arrayUserDish[indexDad].isOrderForFriend == false) {
			arrayUserDish.forEach((item: any, index: any) => {
				if (indexDad === index) {
					arrayUserDish[index].price = parseInt(e) ? parseInt(e) : 0;
				}
			});
		} else {
			arrayUserDish.forEach((item: any, index: any) => {
				if (item.userid === numberUserId) {
					arrayUserDish[index].price = parseInt(e) ? parseInt(e) : 0;
				}
			});
		}
		// console.log("arrayUserDish", arrayUserDish);
		setArrayUserDish(arrayUserDish);
		//Update tổng
		// hiện lên để người tạo thấy đc đã có sự thay đổi
		// meal.totalneed2pay = 0;
		const total = arrayUserDish.reduce((initialTotal: any, item: any, index: number) => {
			return initialTotal + item.price;
		}, 0);

		setTotalPay(total);

		if (total != 0) {
			arrayUserDish.forEach((item: any, index: any) => {
				arrayUserDish[index].need2pay = Math.ceil(
					(parseInt(meal.totalneed2pay) / total) * arrayUserDish[index]?.price,
				);
				// .toFixed(1)
			});
		} else {
			arrayUserDish.forEach((item: any, index: any) => {
				arrayUserDish[index].need2pay = 0
				// .toFixed(1)
			});
		}
		setArrayUserDish([...arrayUserDish]);
		// console.log(arrayUserDish);
		// console.log(total);

		const totaladd = arrayUserDish.reduce((initialTotal: any, item: any, index: number) => {
			return initialTotal + item.price;
		}, 0);

		setTotalPay(totaladd);
	};

	const handleChangeFoodName = (e: any, indexDad: any) => {
		if (idCreator === numberUserId || arrayUserDish[indexDad].isOrderForFriend == false) {
			arrayUserDish.forEach((item: any, index: any) => {
				if (indexDad === index) {
					arrayUserDish[index].name = e.target.value;
				}
			});
		} else {
			arrayUserDish.forEach((item: any, index: any) => {
				if (item.userid === numberUserId) {
					arrayUserDish[index].name = e.target.value;
				}
			});
		}
		setArrayUserDish(arrayUserDish);
	};

	const handlePasteFoodFromFoody = async (e: any, indexDad: any) => {
		let string = e.target.value;
		const stringArray = string.split(" ");

		const count = stringArray.length;
		if (count < 3) {
			return
		}

		let priceString = "";
		if (stringArray[stringArray.length - 1] == "+") {
			string = string.replaceAll('+', '');
			if (containsNumbers(stringArray[stringArray.length - 2])) {
				priceString = stringArray[stringArray.length - 2];
				string = string.replaceAll(stringArray[stringArray.length - 2], '');
			} else {
				return;
			}

			if (containsNumbers(stringArray[stringArray.length - 3])) {
				string = string.replaceAll(stringArray[stringArray.length - 3], '');
			}
		} else {
			if (containsNumbers(stringArray[stringArray.length - 1])) {
				priceString = stringArray[stringArray.length - 1];
				string = string.replaceAll(stringArray[stringArray.length - 1], '');
			} else {
				return;
			}

			if (containsNumbers(stringArray[stringArray.length - 2])) {
				string = string.replaceAll(stringArray[stringArray.length - 2], '');
			}
		}

		priceString = priceString.toString().replaceAll("đ", '');
		priceString = priceString.toString().replaceAll(",", '');
		const price = parseInt(priceString.toString().replaceAll("đ", ''));
		if (price == 0 || !price) {
			return;
		}
		const name = {
			target: {
				value: ""
			}
		};
		name.target.value = string;
		await handleChangeFoodName(name, indexDad);
		await handleChangePrice(price, indexDad);
		setTimeout(function () {
			onFinish(formDish.getFieldsValue());
		}, 1500);
	};

	function containsNumbers(str: any) {
		return /\d/.test(str);
	}

	function refreshRealtime(textReceive: string) {

		// console.log("refresh here");
		// console.log(userRender);
		handleClickFreshRealTime();
		openNotification(textReceive);
	}

	const handleClickFreshRealTime = () => {
		setIsSpin(true);
		getUsers()
			.then(res => {
				// console.log(res);
				setUserRender(res.data.data);
				// console.log(userRender);
				getMealsByID(numberMealId)
					.then(resMeal => {
						// console.log(resMeal);
						setDateMeals(resMeal.data.result.created);
						setIdCreator(resMeal.data.result.creator);
						setMeal(resMeal.data.result);
						updateArrayDishesRealtime(res.data.data, resMeal.data.result, resMeal.data.result.created);
						setIsSpin(false);
					})
					.catch(err => {
						// console.log(err);
						setIsSpin(false);
					});
				setIsSpin(false);
			})
			.catch(err => {
				// console.log(err);
				setIsSpin(false);
			});
		getUser()
			.then((res: any) => {
				// console.log(res);
				setNumberUserId(res.data.data.id);
				setUserName(res.data.data.fullname);
				setIsSpin(false);
			})
			.catch(err => {
				// console.log(err);
				setIsSpin(false);
			});


		const totalInitial = arrayUserDish.reduce((initialTotal: any, item: any, index: number) => {
			return initialTotal + item.price;
		}, 0);
		setTotalPay(totalInitial);
	}

	const handleClickFresh = () => {
		setIsSpin(true);
		getUsers()
			.then(res => {
				// console.log(res);
				setUserRender(res.data.data);
				// console.log(userRender);
				setIsSpin(false);
			})
			.catch(err => {
				// console.log(err);
				setIsSpin(false);
			});
		getUser()
			.then((res: any) => {
				// console.log(res);
				setNumberUserId(res.data.data.id);
				setUserName(res.data.data.fullname);
				setIsSpin(false);
			})
			.catch(err => {
				// console.log(err);
				setIsSpin(false);
			});
		getMealsByID(numberMealId)
			.then(res => {
				// console.log(res);
				setDateMeals(res.data.result.created);
				setIdCreator(res.data.result.creator);
				setMeal(res.data.result);
				updateArrayDishes();
				setIsSpin(false);
			})
			.catch(err => {
				// console.log(err);
				setIsSpin(false);
			});

		const totalInitial = arrayUserDish.reduce((initialTotal: any, item: any, index: number) => {
			return initialTotal + item.price;
		}, 0);
		setTotalPay(totalInitial);
	};

	// Tổng tiền phải trả

	const handleChangeMustPay = (e: any) => {
		if (!e) {
			e = 0;
		} else {
			e = e.toString().replaceAll('.', '');
			e = e.toString().replaceAll('-', '');
		}
		// console.log(e);
		setTotalMustPay(e);
		meal.totalneed2pay = e;
		setMeal(meal);
		if (totalPay != 0) {
			arrayUserDish.forEach((item: any, index: any) => {
				arrayUserDish[index].need2pay = Math.ceil(
					(parseInt(e) / totalPay) * arrayUserDish[index]?.price,
				);
				// console.log(totalPay);
				// console.log(arrayUserDish[index].need2pay);
			});
		} else {
			arrayUserDish.forEach((item: any, index: any) => {
				arrayUserDish[index].need2pay = 0;
				// Math.ceil(
				// 	(parseInt(e) / totalPay) * arrayUserDish[index]?.price,
				// );
				// console.log(arrayUserDish[index].need2pay);
			});
		}
		setArrayUserDish([...arrayUserDish]);
	};

	const handlePay = () => {
		setIsModalOpen(true);
	};

	const handleShowList = () => {
		// console.log(arrayUserDish);
		const countList: any = [];
		let i = 0;
		groupBy(arrayUserDish, "name").forEach(element => {
			if (element[0].name != "") {
				countList[i] = element;
				i = i + 1;
			}
		});
		// console.log(countList);
		setArrayCountDish(countList);
		setIsOpenShowList(true);
	};

	function getRandomColor() {
		const letters = '0123456789ABCDEF';
		let color = '#';
		for (let i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * 16)];
		}
		return color;
	}

	const handleShowListRandom = () => {
		// console.log(arrayUserDish);
		const countList: any = [];
		let i = 0;
		arrayUserDish.forEach((element: any) => {
			if(element.name != "") {
				countList[i] = { option: element.userid, style: { backgroundColor: getRandomColor(), textColor: getRandomColor() } };
				i = i + 1;
			}
		});
		console.log(countList);
		if (countList.length == 0) { return; }
		// countList = countList.sort(() => 0.5 - Math.random());
		for (let i = countList.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[countList[i], countList[j]] = [countList[j], countList[i]];
		}

		setDataRandom(countList);
		setIsRandomOpen(true);
	};

	const handleOk = () => {
		const paramsMeal = {
			shoplink: meal.shoplink,
			shopprice: meal.shopprice,
			totalneed2pay: parseInt(meal.totalneed2pay),
			creator: meal.creator,
			payer: meal.payer,
			status: 'paid',
			created: meal.created,
			modified: meal.modified,
		};

		// console.log(paramsMeal);

		onFinish(formDish.getFieldsValue());
		updateMeals(paramsMeal, numberMealId)
			.then(res => {
				// console.log(res);
				message.success('Bạn đã thanh toán thành công');
				window.location.replace('/home');
			})
			.catch(err => {
				// console.log(err);
			});
		setIsModalOpen(false);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
		setIsOpenShowList(false);
		setIsRandomOpen(false);
	};

	const handleCopy = (itemDad: any) => {
		const itemCopy = arrayUserDish.find((item: any, index: number) => {
			if (item.userid == itemDad.id) {
				return item;
			}
		});

		arrayUserDish.forEach((item: any, index: number) => {
			if (item.userid == numberUserId) {
				return (item.name = itemCopy.name), (item.price = itemCopy.price);
			}
		});
		setArrayUserDish([...arrayUserDish]);
		// meal.totalneed2pay = 0;
		// tính tổng lại
		const total = arrayUserDish.reduce((initialTotal: any, item: any, index: number) => {
			return initialTotal + item.price;
		}, 0);

		setTotalPay(total);
		setTimeout(function () {
			onFinish(formDish.getFieldsValue());
		}, 1500);
	};

	const handleClickCopyPaste = (indexDad: any) => {
		navigator.clipboard.readText()
			.then(text => {

				const stringArray = text.split("\n");
				// console.log('Pasted content: ', stringArray);
				const textChange = stringArray[0] + " " + stringArray[stringArray.length - 1];
				const e = {
					target: {
						value: textChange
					}
				};
				handlePasteFoodFromFoody(e, indexDad);
			})
			.catch(err => {
				console.error('Failed to read clipboard contents: ', err);
			});

	};

	const handleOrderForFriend = (itemDad: any) => {
		arrayUserDish.forEach((item: any, index: number) => {
			if (item.userid == itemDad.id) {
				return item.isOrderForFriend = false;
			}
		});
		setArrayUserDish([...arrayUserDish]);
	};

	function groupBy(collection: any, property: any) {
		let i = 0, val, index;
		const values = [], result = [];
		for (; i < collection.length; i++) {
			val = collection[i][property].trim();
			index = values.indexOf(val);
			if (index > -1)
				result[index].push(collection[i]);
			else {
				values.push(val);
				result.push([collection[i]]);
			}
		}
		return result;
	}

	const checkNumber = (e: any, index: any) => {
		if (e) {
			e = e.toString().replaceAll('-', '');
		} else {
			e = 0
		}
	}

	const handleChat = () => {
		//
	}

	const onFinishMessage = (values: any) => {
		setIsChatOpen(false)
		// console.log(values);
		// const arrMessageAdd = arrMessage.push(["a"]);
		// setArrMessage(arrMessage);
		// const arrMessageAdd = []
		// console.log(arrMessage);
		// arrMessage.push({
		// 	"name" : userName,
		// 	"message": values.msg,
		// 	"created": Moment(new Date()).format('DD/MM h:m')
		// })

		setArrMessage(arrMessage);

		sendWithType(4, values.msg);
		setIsChatOpen(true);
		formMessage.resetFields();
	}

	const handleSpinClick = () => {
		if (!mustSpin) {
			const newPrizeNumber = Math.floor(Math.random() * dataRandom.length);
			setPrizeNumber(newPrizeNumber);
			setMustSpin(true);
		}
	}

	return (
		<>
			<Spin size="small" spinning={isSpin} delay={1000}>
				<div
					className="bg-dish mx-auto border border-gray-500 p-5 rounded-md form-order"
					style={{ height: '100%' }}
				>
					<h1 className="text-center mb-5">DANH SÁCH CHỌN MÓN</h1>
					<div className="flex mb-5">
						<div className="mx-[8rem]">
							<div>
								<p className="text-red-600">Người đăng nhập hiện tại: {userName}</p>
							</div>
							<div className="flex">
								<p>Ngày: {Moment(dateMeals).format('DD-MM-YYYY')}</p>
							</div>
							<div className="flex">
								<p>
									Shop:&nbsp;
									<a href={meal.shoplink} target="_blank" rel="noreferrer">
										{meal.shoplink}
									</a>
								</p>
							</div>
						</div>
						<div className="mx-[7rem]">
							<div className="flex mb-2">
								<p className="w-44 mb-0">Tổng giá:</p>
								<InputNumber
									formatter={(value: any) => `${value}`.replaceAll(/\B(?=(\d{3})+(?!\d))/g, '.')}
									parser={(value: any) => parseInt(value.replaceAll(".", ""))}
									addonAfter="VND"
									disabled
									value={totalPay ? totalPay : 0}
								/>
								{/* {totalPay ? "totalPay" : "initialPrice"} */}
							</div>
							<div className="flex mb-2">
								<p className="w-44 mb-0">Tổng giá thực tế:</p>
								<InputNumber
									formatter={(value: any) => `${value}`.replaceAll(/\B(?=(\d{3})+(?!\d))/g, '.')}
									parser={(value: any) => parseInt(value.replaceAll(".", ""))}
									addonAfter="VND"
									disabled={
										numberUserId !== idCreator ||
										meal.status == 'paid' ||
										meal.status == 'done' ||
										meal.status == 'deleted'
									}
									value={meal.totalneed2pay}
									onChange={(e: any) => {
										handleChangeMustPay(e);
									}}
								/>
							</div>
							{numberUserId === meal.creator && (
								<div className="flex">
									<p className="w-44 mb-0"></p>
									<Button
										type="primary"
										className="w-full"
										onClick={handlePay}
										disabled={
											meal.status == 'paid' || meal.status == 'done' || meal.status == 'deleted'
										}
									>
										Thanh toán
									</Button>
								</div>
							)}
						</div>
					</div>
					<Form
						labelCol={{ span: 8 }}
						wrapperCol={{ span: 32 }}
						name="dynamic_form_nest_item"
						onFinish={onFinish}
						autoComplete="off"
						// initialValues={{ modules: [''], features: [''] }}
						form={formDish}
						className="snap-y"
					>
						<div className="mb-10">
							{meal.status == 'new' ? (
								<Form.Item wrapperCol={{ offset: 8, span: 32 }} className="button-submit">
									<div className="w-[200px] mx-auto flex">
										<Button type="primary" htmlType="submit">
											Lưu thông tin
										</Button>
										{/* <Button
											type="primary"
											className="ml-5"
											onClick={() => {
												handleClickFresh();
											}}
										>
											Fresh Trang
										</Button> */}
										<Button
											type="primary"
											className="ml-5"
											onClick={() => {
												handleShowList();
											}}
										>
											Tổng hợp
										</Button>

										<Button
											type="primary"
											className="ml-5"
											onClick={() => {
												handleShowListRandom();
											}}
										>
											Random lấy đồ
										</Button>
									</div>
								</Form.Item>
							) : (
								''
							)}
						</div>
						<div className="underline underline-offset-4 mb-5">
							<div className="flex justify-evenly ">
								<p className="w-32 text-center text-base font-semibold">Tên</p>
								<div className="flex justify-start w-[47rem]">
									<p className="w-[20rem]  text-base font-semibold">Món</p>
									<p className="w-[10rem]  text-base font-semibold">Giá</p>
									<p className="w-[10rem]  text-base font-semibold">Tiền phải trả</p>
								</div>
							</div>
						</div>
						<Form.List name="modules">
							{(fields, { add, remove }) => (
								<>
									{userRender.map((itemDad: any, indexDad: any) => {
										return (
											<div key={indexDad}>
												<Form.Item key={indexDad}>
													<div className="flex justify-evenly">
														<h1 className="w-32">{itemDad.fullname}</h1>
														<Form.List name={indexDad}>
															{(fields, { add, remove }) => (
																<div className="flex justify-evenly">
																	<Form.Item
																		name="name"
																		className="input-select-food"
																	>
																		<Input
																			className="input-select-food"
																			type="text"
																			disabled={
																				(itemDad.id != numberUserId &&
																					numberUserId != meal.creator && ((arrayUserDish.length > 0) ? arrayUserDish[indexDad].isOrderForFriend : true)) ||
																				meal.status === 'paid' ||
																				meal.status === 'done' ||
																				meal.status === 'deleted'
																			}
																			onChange={e => {
																				handlePasteFoodFromFoody(e, indexDad).then(r => {
																					handleChangeFoodName(e, indexDad);
																				});
																			}}
																		/>
																	</Form.Item>
																	<Form.Item
																		name="price"
																		className="input-select"
																		rules={[
																			{
																				required: true,
																				message:
																					'Please input your price or 0!',
																			},
																		]}
																	>
																		<InputNumber
																			className="input-select"
																			formatter={(value: any) => `${value}`.replaceAll(/\B(?=(\d{3})+(?!\d))/g, '.')}
																			parser={(value: any) => parseInt(value.replaceAll(".", ""))}
																			disabled={
																				(itemDad.id != numberUserId &&
																					numberUserId != meal.creator && ((arrayUserDish.length > 0) ? arrayUserDish[indexDad].isOrderForFriend : true)) ||
																				meal.status === 'paid' ||
																				meal.status === 'done' ||
																				meal.status === 'deleted'
																			}
																			onChange={e => {
																				handleChangePrice(e, indexDad);
																				checkNumber(e, indexDad);
																			}}
																			addonAfter="VND"
																			id={"input_" + indexDad}
																		/>
																	</Form.Item>
																	<Form.Item className="input-select" name="need2pay">
																		<InputNumber
																			className="input-select"
																			disabled
																			formatter={
																				(value: any) => {
																					return `${value}`.replaceAll(/\B(?=(\d{3})+(?!\d))/g, '.');
																				}
																			}
																			parser={(value: any) => parseInt(value.replaceAll(".", ""))}
																			addonAfter="VND"
																		/>
																	</Form.Item>
																	<Button
																		className="mr-2"
																		type="primary"
																		disabled={
																			// (arrayUserDish.length > 0) ? (arrayUserDish[indexDad].isOrderForFriend ? false : true) : true ||
																			meal.status === 'paid' ||
																			meal.status === 'done' ||
																			meal.status === 'deleted'
																		}
																		onClick={() => {
																			handleOrderForFriend(itemDad);
																			handleClickCopyPaste(indexDad);
																		}}
																	>
																		Dán
																	</Button>
																	<Button
																		className="mr-2"
																		type="primary"
																		onClick={() => {
																			handleCopy(itemDad);
																		}}
																		disabled={
																			numberUserId === itemDad.id ||
																			meal.status === 'paid' ||
																			meal.status === 'done' ||
																			meal.status === 'deleted'
																		}
																	>
																		Nhân bản
																	</Button>
																	<Button
																		className="mr-2"
																		type="primary"
																		onClick={() => {
																			handleOrderForFriend(itemDad);
																		}}
																		disabled={
																			numberUserId === itemDad.id ||
																			meal.status === 'paid' ||
																			meal.status === 'done' ||
																			meal.status === 'deleted'
																		}
																	>
																		Đặt giúp
																	</Button>
																</div>
															)}
														</Form.List>
													</div>
												</Form.Item>
											</div>
										);
									})}
								</>
							)}
						</Form.List>
					</Form>
					{/* </div> */}
				</div>

				<div
					className="divFixed"
					hidden={meal.status != 'new'}
				>
					<Button
						className="btnFixed"
						onClick={() => {
							onFinish(formDish.getFieldsValue());
						}}
					>
						Lưu thông tin
					</Button>
					<Button
						className="btnFixed"
						onClick={() => {
							isChatOpen ? setIsChatOpen(false) : setIsChatOpen(true)
						}}
					>
						Chat
					</Button>
					<Button
						className="btnFixed"
						onClick={() => {
							handleClickFresh();
						}}
					>
						Fresh Trang
					</Button>

					<Button
						className="btnFixed"
						onClick={() => {
							handleShowListRandom();
						}}
					>
						Random lấy đồ
					</Button>

				</div>
				<div
					className="chat-popup"
					id="myForm"
					hidden={!isChatOpen}
				>
					<Form
						className="form-container"
						onFinish={onFinishMessage}
						form={formMessage}
					>
						<label><b>Message</b></label>
						<List
							className="messages"
							dataSource={arrMessage}
							bordered={false}
							renderItem={(item: any) => (
								<List.Item className="container"
								>
									<span style={{ color: item.color }} >{item.name}</span><br />
									<span style={{ color: item.color }} className='mgl-5'>{item.message}</span><br />
									<span className="time-right">{Moment(new Date(item.created)).add(7, 'h').format('DD/MM H:m')}</span>
								</List.Item>
							)}
						/>
						<Form.Item
							name="msg"
						>
							<Input
								placeholder="Type message.."
								autoComplete="off"
								name="msg"
								required>
							</Input>
						</Form.Item>
						<Button
							className="btnFixed btn"
							type="primary" htmlType="submit"
						>
							Send
						</Button>
						<Button
							className="btnFixed btn"
							onClick={() => {
								setIsChatOpen(false);
							}}
						>
							Close
						</Button>
					</Form>
				</div>
			</Spin>
			<Modal centered visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
				<p className="text-center">Bạn có đồng ý thanh toán</p>
			</Modal>

			<Modal centered visible={isOpenShowList} onOk={handleCancel} onCancel={handleCancel}>
				<List
					header={<div>Tổng hợp</div>}
					dataSource={arrCountDish}
					bordered={false}
					renderItem={(item: any) => (
						<List.Item
						>
							{item[0]?.name} = Số lượng: {item.length} * giá: {item[0]?.price} (VND)
						</List.Item>
					)}
				/>
			</Modal>

			<Modal centered visible={isRandomOpen} onOk={handleCancel} onCancel={handleCancel}>
				<>
					<Wheel
						mustStartSpinning={mustSpin}
						prizeNumber={prizeNumber}
						data={dataRandom}

						onStopSpinning={() => {
							console.log(prizeNumber);
							
							const user = userRender.filter( (user:any) => user.id === dataRandom[prizeNumber].option);

							console.log(user);
							const textRandom = `Chúc mừng ${user[0].fullname} sẽ đi lấy đồ`;
							setTextRandom(textRandom);
							// console.log(textRandom);
							
							setMustSpin(false);
						}}
					/>
					<button className="btnFixed btn" onClick={handleSpinClick}>SPIN</button>
					<h3>{textRandom}</h3>
				</>
			</Modal>


		</>
	);
}
